import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router, RouterLink } from '@angular/router';
import { RouteOption, routeOptions } from '../../interfaces/data/delegate';
import { MrpScrolltopComponent } from '../../services/mrp-scrolltop/mrp-scrolltop.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';


@Component({
    selector: 'app-delegate',
    templateUrl: './delegate.component.html',
    styleUrls: ['./delegate.component.css'],
    imports: [MrpScrolltopComponent, MatFormField, MatLabel, MatSelect, MatOption, RouterLink]
})
export class DelegateComponent implements OnInit {

delegateroutes: RouteOption[] = routeOptions; 

  isBrowser = false;
  constructor(private router: Router, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) this.logPage('delegate');    
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }

  onRouteSelect(path: string): void {
    if (path) {
      this.router.navigate([path]);
    }
  }

}
